export default {
    shopInfo: JSON.parse(sessionStorage.getItem('shopInfo')), // 商城基本信息
    wechatAuth: JSON.parse(sessionStorage.getItem('wechatAuth')), // 微信授权信息
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {}, // 用户信息
    token: localStorage.getItem('h5_access_token') || '',
    openid: localStorage.getItem('openid') || '',
    wxuserInfo: JSON.parse(localStorage.getItem('wxuserInfo')) || {} //微信头像、微信用户名
}
